/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { Container } from 'semantic-ui-react';
import parse from 'html-react-parser';

import Layout from '../components/layout';
import SEO from '../components/seo';

const StaticPage = ({ data: { page } }) => (
  <Layout>
    <SEO title={page.title} />
    <Container className="wordpress">
      <h1 style={{ marginTop: '3rem' }}>{page.title}</h1>
      {page.content && parse(page.content)}
    </Container>
  </Layout>
);

StaticPage.propTypes = {
  data: PropTypes.shape({
    page: PropTypes.shape(),
  }).isRequired,
};

export default StaticPage;

export const query = graphql`
  query staticPage($id: String) {
    page: wpPage(id: { eq: $id }) {
      title
      content
    }
  }
`;
